/* eslint-disable global-require */
/**
 * i18n.js
 *
 * This will setup the i18n language files and locale data for your app.
 *
 */
import { getTranslationsMessages } from '@quintoandar/js-intl';

export const getLibsTranslations = async (locale) => {
  const libsMessages = await getTranslationsMessages(locale, [
    'cozy-core',
    'bioma-pickers',
  ]);

  return libsMessages;
};

export const getMessages = async (locale) => {
  let projectTranslations;

  if (locale === 'es-MX') {
    projectTranslations = await import('./translations/es-MX.json');
  } else {
    projectTranslations = await import('./translations/pt-BR.json');
  }

  const packagesTranslations = await getLibsTranslations(locale);

  return { ...packagesTranslations, ...projectTranslations };
};
